<h2 class="title-section" *ngIf="block.title">{{ block.title }}</h2>

<div *ngFor="let parag of block?.content.text">
  {{ parag.trim() || '&nbsp;' }}
</div>
